import { appRootURL, EnvironmentType } from "@/constants";
import type { ColorsInterface } from "@/features/survey/types/survey.mapInterface.types";

export const defaultZoomLevel = 4;
export const defaultMapTextSize = 28;
export const defaultMapCenter = [-95, 40];
export const iconColorYellow = "#F9DD4B";
export const iconColorBlack = "#012A2D";
export const iconColorActive = "#103F60";
export const iconColorInactive = "#0976C3";
export const iconColorShortlist = "#003f2d";
export const iconColorLeaseComp = "#E47444";
export const starIcon = "starIcon";
export const emptyIcon = "emptyIcon";
export const squareIcon = "squareIcon";

export const BAM_MAP_STYLES = {
  cbreLight: "cbreLight",
  cbreDark: "cbreDark",
  emeraldEsriHybrid: "emeraldEsriHybrid",
  emeraldBingHybrid: "emeraldBingHybrid",
  mapboxStreets: "mapboxStreets",
  mapboxGray: "mapboxGray",
  mapboxDark: "mapboxDark",
};

export const PDFPaperSize = {
  Landscape: "Landscape",
  Portrait: "Portrait",
};

export const BAM_MAP_STYLE_LIST = [
  "cbreLight",
  "cbreDark",
  "esriHybrid",
  "bingHybrid",
  "mapboxStreets",
  "mapboxGray",
  "mapboxDark",
];

export const BAM_MAP_STYLE_DISPLAY_NAMES = {
  [BAM_MAP_STYLES.cbreLight]: "CBRE Light",
  [BAM_MAP_STYLES.cbreDark]: "CBRE Dark",
  [BAM_MAP_STYLES.emeraldEsriHybrid]: "Esri Hybrid",
  [BAM_MAP_STYLES.emeraldBingHybrid]: "Bing Hybrid",
  [BAM_MAP_STYLES.mapboxStreets]: "Mapbox Streets",
  [BAM_MAP_STYLES.mapboxGray]: "Mapbox Gray",
  [BAM_MAP_STYLES.mapboxDark]: "Mapbox Dark",
};

const appRootSrc =
  EnvironmentType.indexOf("local") !== -1 ? `${appRootURL}/src` : appRootURL;

export const BAM_MAP_STYLE_SOURCES = {
  [BAM_MAP_STYLES.cbreLight]:
    "mapbox://styles/cbre-lig/cjykc8tc90sny1cotxp3lwmhw",
  [BAM_MAP_STYLES.cbreDark]:
    "mapbox://styles/cbre-lig/ckltq1qby1h7017o1g25f2e05",
  esriHybrid: `${appRootSrc}/assets/map-styles/emerald-esri-hybrid.json`,
  [BAM_MAP_STYLES.emeraldEsriHybrid]: `${appRootSrc}/assets/map-styles/emerald-esri-hybrid.json`,
  [BAM_MAP_STYLES.emeraldBingHybrid]: `${appRootSrc}/assets/map-styles/emerald-bing-hybrid.json`,
  [BAM_MAP_STYLES.mapboxStreets]: "mapbox://styles/mapbox/streets-v10",
  [BAM_MAP_STYLES.mapboxGray]: "mapbox://styles/mapbox/light-v9",
  [BAM_MAP_STYLES.mapboxDark]: "mapbox://styles/mapbox/dark-v9",
};

export const BAM_MAP_EVENT_TYPE: Record<string, string> = {
  zoomEnd: "mapZoomLevel",
  dragEnd: "mapCentroid",
  reset: "reset",
};

export const colors: ColorsInterface = {
  Primary: ["#003f2d", "#24a787", "#778f9c", "#c2c2c8", "#c9bca2"],
  Secondary: [
    "#d43545",
    "#e47444",
    "#ed5f8a",
    "#7e76dd",
    "#a23f97",
    "#41afca",
    "#0976c3",
    "#109335",
    "#6ca428",
    "#f9dd4b",
  ],
  Neutral: ["#7f8480", "#526668", "#594139", "#262626", "#cea12c"],
};

export const poiIcons = [
  "circle",
  "star",
  "local_airport",
  "storefront",
  "print",
  "directions_car_filled",
  "car_repair",
  "account_balance",
  "content_cut",
  "coffee",
  "local_convenience_store",
  "anchor",
  "water",
  "fitness_center",
  "directions_bus",
  "local_parking",
  "golf_course",
  "local_hospital",
  "medical_services",
  "maps_home_work",
  "corporate_fare",
  "pets",
  "local_dining",
  "shopping_cart",
  "school",
  "theater_comedy",
  "local_phone",
  "train",
  "local_shipping",
  "directions_boat",
  "pedal_bike",
  "directions_bike",
  "ev_station",
  "subway",
  "tram",
  "bolt",
];
